import styled from 'styled-components';

export const Chart = styled.div`
	width: 100%;
`;

export const ChartTitle = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin-bottom: 20px;

	p {
		color: #000;
		text-align: center;
		font-size: 16px;
		font-weight: 400;
		line-height: 20px;
		margin: 0;
	}

	h4 {
		color: #6d25a8;
		text-align: center;
		font-size: 24px;
		font-weight: 700;
		line-height: normal;
		text-decoration-line: underline;
		margin-top: 10px;
		margin-bottom: 10px;
	}
`;
